const formatDate = (isoString) => {
    if (!isoString)
        return '';
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
const parseDateFromString = (value) => {
    const [year, month, day] = value.split('-').map(Number);
    return new Date(year, month - 1, day);
};
const validateNumericInput = (value) => {
    const onlyDigits = String(value).replace(/\D/g, '');
    if (onlyDigits === '')
        return 0;
    const num = parseInt(onlyDigits, 10);
    if (num > 999)
        return 999;
    if (num < 0)
        return 0;
    return num;
};
export { formatDate, parseDateFromString, validateNumericInput };
